import * as actionTypes from "./actionTypes";

export const fetchRefundsRequest = () => ({
  type: actionTypes.FETCH_REFUNDS_REQUEST,
});

export const fetchRefundsSuccess = (refunds) => ({
  type: actionTypes.FETCH_REFUNDS_SUCCESS,
  payload: refunds,
});

export const fetchRefundsFailure = (error) => ({
  type: actionTypes.FETCH_REFUNDS_FAILURE,
  payload: error,
});

export const approveRefundRequest = (refundId, creditNoteData) => ({
  type: actionTypes.APPROVE_REFUND_REQUEST,
  payload: { refundId, creditNoteData },
});

export const approveRefundSuccess = (refund) => ({
  type: actionTypes.APPROVE_REFUND_SUCCESS,
  payload: refund,
});

export const approveRefundFailure = (error) => ({
  type: actionTypes.APPROVE_REFUND_FAILURE,
  payload: error,
});

export const rejectRefundRequest = (refundId, reason) => ({
  type: actionTypes.REJECT_REFUND_REQUEST,
  payload: { refundId, reason },
});

export const rejectRefundSuccess = (refund) => ({
  type: actionTypes.REJECT_REFUND_SUCCESS,
  payload: refund,
});

export const rejectRefundFailure = (error) => ({
  type: actionTypes.REJECT_REFUND_FAILURE,
  payload: error,
});

export const markRefundRefundedRequest = (refundId) => ({
  type: actionTypes.MARK_REFUND_REFUNDED_REQUEST,
  payload: { refundId },
});

export const markRefundRefundedSuccess = (refund) => ({
  type: actionTypes.MARK_REFUND_REFUNDED_SUCCESS,
  payload: refund,
});

export const markRefundRefundedFailure = (error) => ({
  type: actionTypes.MARK_REFUND_REFUNDED_FAILURE,
  payload: error,
});
export const generateRefundFromFlaggedInvoiceRequest = (invoice) => ({
  type: actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_REQUEST,
  payload: { invoiceData: invoice },
});

export const generateRefundFromFlaggedInvoiceSuccess = (refund) => ({
  type: actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_SUCCESS,
  payload: refund,
});

export const generateRefundFromFlaggedInvoiceFailure = (error) => ({
  type: actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_FAILURE,
  payload: error,
});